import { getPostLoginRedirectUrl, isRedirectUrlSameProduct } from "utils/environment";

export function isLocalhostHost() {
  const host = window.location.hostname;
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host === "[::1]" ||
    /\.local$/.test(host)
  );
}

export function isDevOrLocalhostAuth() {
  const isLocal = isLocalhostHost();
  const isDev = (process.env.REACT_APP_API_URL || "").includes("dev");
  return isLocal || isDev;
}

export function getSubdomainFromAppId(appId) {
  switch (appId) {
    case 1:
      return "tax";
    case 2:
      return "epr";
    case 3:
      return "invoice";
    case 4:
      return "tax-agent";
    case 5:
      return "omp";
    default:
      return "tax";
  }
}

/** Post-login redirect (credentials or 2FA success). */
export function handlePostLoginRedirect(res, navigate) {
  const params = new URLSearchParams(window.location.search);
  const redirectUrl = params.get("redirectUrl");
  const subdomain = getSubdomainFromAppId(res?.app_id);

  if (redirectUrl && isRedirectUrlSameProduct(redirectUrl)) {
    window.location.href = redirectUrl;
    return;
  }

  if (!isLocalhostHost()) {
    const postLoginUrl = getPostLoginRedirectUrl(subdomain);
    window.location.href =
      postLoginUrl || `https://${subdomain}${process.env.REACT_APP_COOKIES || ""}/`;
    return;
  }

  navigate("/home");
}
